import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router";
import Actions from "../../components/Common/Actions";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import ListPageLayout from "../../components/Layout";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";

const ViewService = () => {
  const navigate = useNavigate();
  const search = "";
  const sort = "";

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}services/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const dataSource = records.map((el) => ({ ...el, key: el._id }));
  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      fixed: "left",
      key: "serial",
      width: 80,
    },
    {
      title: "Service Name",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 300,
    },
    {
      title: "Specialisations / Service Categories",
      render: (text, record, index) => record.categories.length,
      key: "categories",
      width: 250,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          viewLabel="View Service Categories"
          onClickView={() =>
            navigate(`/web-bookings/${record.slug_url}/view-service-categories`)
          }
        />
      ),
    },
  ];
  const handlePageChange = usePageChange(pagination, setPagination);

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Web Bookings, Consultations & Appointments",
        link: "/web-bookings/home-healthcare-bookings",
      },
      {
        text: "View Service",
        link: "",
      },
    ],
    [],
  );

  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          className=" healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable viewMed_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
    ></ListPageLayout>
  );
};

export default ViewService;
